<template>
  <span>
    <span v-for="item in data" :key="item.id" v-if="value == item.id">
      {{ item.label }}
    </span>
  </span>
</template>

<script>
export default {
  name: "EspEnumView",
  data() {
    return {}
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    value: {
      type: [Number, String],
      default: -100
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/common/enum/EspEnumView.vue